module.exports = __webpack_public_path__ + "static/media/girl.9e3959fc.png";